var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExporticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7167 19.0412H7.28332C3.19165 19.0412 1.44165 17.2912 1.44165 13.1996V13.0912C1.44165 9.39124 2.89998 7.60791 6.16665 7.29957C6.49998 7.27457 6.81665 7.52457 6.84998 7.86624C6.88332 8.20791 6.63332 8.51624 6.28332 8.54957C3.66665 8.79124 2.69165 10.0246 2.69165 13.0996V13.2079C2.69165 16.5996 3.89165 17.7996 7.28332 17.7996H12.7167C16.1083 17.7996 17.3083 16.5996 17.3083 13.2079V13.0996C17.3083 10.0079 16.3166 8.77457 13.65 8.54957C13.3083 8.51624 13.05 8.21624 13.0833 7.87457C13.1166 7.53291 13.4083 7.27457 13.7583 7.30791C17.075 7.59124 18.5583 9.38291 18.5583 13.1079V13.2162C18.5583 17.2912 16.8083 19.0412 12.7167 19.0412Z",
    fill: "#1D244A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.5253C9.65833 13.5253 9.375 13.242 9.375 12.9003V2.16699C9.375 1.82533 9.65833 1.54199 10 1.54199C10.3417 1.54199 10.625 1.82533 10.625 2.16699V12.9003C10.625 13.2503 10.3417 13.5253 10 13.5253Z",
    fill: "#1D244A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.4585C9.8417 14.4585 9.68337 14.4002 9.55837 14.2752L6.7667 11.4835C6.52503 11.2419 6.52503 10.8419 6.7667 10.6002C7.00837 10.3585 7.40837 10.3585 7.65003 10.6002L10 12.9502L12.35 10.6002C12.5917 10.3585 12.9917 10.3585 13.2334 10.6002C13.475 10.8419 13.475 11.2419 13.2334 11.4835L10.4417 14.2752C10.3167 14.4002 10.1584 14.4585 10 14.4585Z",
    fill: "#1D244A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExporticon);
export default __webpack_public_path__ + "static/media/exporticon.899d5f418c22d373e8492424290411fa.svg";
export { ForwardRef as ReactComponent };